import cn from "classnames";
import { CSSProperties, PropsWithChildren } from "react";

import styles from "./Skeleton.module.scss";

type BoxProps = {
  w?: number | string;
  h?: number | string;
  r?: number | string;
  className?: string;
  style?: CSSProperties;
};

/** One shimmering placeholder block. Sizes in px or any CSS length. */
export const Sk: React.FC<BoxProps> = ({ w = "100%", h = 14, r = 8, className, style }) => (
  <span className={cn(styles.sk, className)} style={{ width: w, height: h, borderRadius: r, ...style }} aria-hidden />
);

/** Lines of text: the last one shorter, like a real paragraph. */
export const SkText: React.FC<{ lines?: number; h?: number; gap?: number; last?: string; className?: string }> = ({
  lines = 3,
  h = 12,
  gap = 10,
  last = "60%",
  className,
}) => (
  <span className={cn(styles.text, className)} style={{ gap }} aria-hidden>
    {Array.from({ length: lines }, (_, i) => (
      <Sk key={i} h={h} w={i === lines - 1 && lines > 1 ? last : "100%"} r={h / 2} />
    ))}
  </span>
);

/** A surface with the app's card look, for skeletons of cards and panels. */
export const SkCard: React.FC<PropsWithChildren<{ className?: string; padded?: boolean }>> = ({
  className,
  padded = true,
  children,
}) => <div className={cn(styles.card, padded && styles.padded, className)}>{children}</div>;

/** Marks a region as loading for assistive tech while the placeholders are on screen. */
export const SkRegion: React.FC<PropsWithChildren<{ className?: string; label?: string }>> = ({ className, label, children }) => (
  <div className={className} role="status" aria-busy="true" aria-label={label}>
    {children}
  </div>
);
